import { AbstractControl, ValidatorFn, FormGroup, ValidationErrors } from '@angular/forms';

export function MaxValueValidator(max: number): ValidatorFn
{
  return (control: AbstractControl): ValidationErrors | null =>
  {
    const input = control.value,
      isValid = input > max;

    if (isValid)
    {
      return { 'maxValue': { max } }
    }
    else
    {
      return null;
    }
  };
}


export function MinValueValidator(min: number): ValidatorFn
{
  return (control: AbstractControl): ValidationErrors | null =>
  {
    const input = control.value,
      isValid = input < min;

    if (isValid)
    {
      return { 'minValue': { min } }
    }
    else
    {
      return null;
    }
  };
}

export function conditionalNumberValidator(
  form: FormGroup,
  booleanField: string,
  numberField: string
): ValidatorFn
{
  return (control: AbstractControl): ValidationErrors | null =>
  {
    const group = control?.parent ?? form;

    // Coerce boolean to strict true when it’s true or 'true'
    const rawBool = group?.get(booleanField)?.value;
    const isTrue = rawBool === true || rawBool === 'true';

    // Coerce number to a numeric value (null when empty/undefined)
    const rawNum = group?.get(numberField)?.value;
    const num = rawNum === '' || rawNum === null || rawNum === undefined
      ? null
      : (typeof rawNum === 'number' ? rawNum : parseFloat(rawNum));

    if (isTrue)
    {
      return num === 0 ? null : { mustBeZero: { message: `${numberField} must be 0 when ${booleanField} is true` } };
    }

    if (num === null || Number.isNaN(num) || num <= 0)
    {
      return { mustBeGreaterThanZero: { message: `${numberField} must be greater than 0 when ${booleanField} is false` } };
    }

    return null;
  };
}

export function conditionalArrayValidator(
  form: FormGroup,
  booleanField: string,
  arrayField: string,
  needArrayWhenTrue: boolean
): ValidatorFn
{
  return (control: AbstractControl): ValidationErrors | null =>
  {
    let booleanValue = control.get(booleanField)?.value;

    if (booleanValue == undefined)
    {
      booleanValue = form.get(booleanField)?.value;
    }

    let arrayValue = control.get(arrayField)?.value;

    if (arrayValue == undefined)
    {
      arrayValue = form.get(arrayField)?.value;
    }

    if (booleanValue === needArrayWhenTrue && (!arrayValue || arrayValue.length == 0))
    {
      return { required: { message: `${arrayField} must have value when ${booleanField} is ${needArrayWhenTrue}` } };
    }

    return null;
  };
}

export function conditionalRequiredIfNotNullValidator(
  form: FormGroup,
  isNullField: string,
  otherField: string
): ValidatorFn
{
  return (control: AbstractControl): ValidationErrors | null =>
  {
    let isNullValue = control.get(isNullField)?.value;

    if (isNullValue == undefined)
    {
      isNullValue = form.get(isNullField)?.value;
    }

    let otherValue = control.get(otherField)?.value;

    if (otherValue == undefined)
    {
      otherValue = form.get(otherField)?.value;
    }

    if (isNullValue != null && otherValue == null)
    {
      return { required: { message: `${otherField} is required if ${isNullField} is set` } };
    }

    return null;
  };
}

export function fieldLessThanComparisonFieldValidator(group: FormGroup, fieldName: string, comparisonFieldName: string): any
{
  if (group)
  {
    if (group.get(fieldName).value < group.get(comparisonFieldName).value)
    {
      return { isLess: true };
    }
  }

  return null;
}

export function fieldGreaterThanComparisonFieldValidator(group: FormGroup, fieldName: string, comparisonFieldName: string): any
{
  if (group)
  {
    if (group.get(fieldName).value < group.get(comparisonFieldName).value)
    {
      return { isLess: true };
    }
  }

  return null;
}


export function RequiredIfAnyOfTheseFieldsAreEmptyValidator(theseFieldNames: string[]): ValidatorFn 
{
  return (control: AbstractControl): ValidationErrors | null =>
  {
    let allTheseFieldsHaveValues: boolean = true;

    theseFieldNames.map(t =>
    {
      const parentControls: any = control.parent.controls;

      if (!parentControls[t as keyof typeof parentControls].value)
      {
        allTheseFieldsHaveValues = false;
      }
    });

    if (!allTheseFieldsHaveValues)
    {
      return { 'requirementsNotMet': true };
    }

    return null;
  }
}

export function TheseFieldsOrThoseFieldsRequiredValidator(theseFieldNames: string[], thoseFieldNames: string[]): ValidatorFn 
{
  return (control: AbstractControl): ValidationErrors | null =>
  {
    let allTheseFieldsHaveValues: boolean = true;
    let allThoseFieldsHaveValues: boolean = true;

    const parentControls: any = control.parent.controls;

    theseFieldNames.map(t =>
    {
      if (!parentControls[t as keyof typeof parentControls].value)
      {
        allTheseFieldsHaveValues = false;
      }
    });

    thoseFieldNames.map(t =>
    {
      if (!parentControls[t as keyof typeof parentControls].value)
      {
        allThoseFieldsHaveValues = false;
      }
    });

    if (!allTheseFieldsHaveValues && !allThoseFieldsHaveValues)
    {
      return { 'requirementsNotMet': true };
    }

    return null;
  }
}
